import cx from 'classnames';

import s from './CardTitle.module.scss';

interface IProps {
  bold?: boolean;
  size?: 'sm';
  className?: string;
}

const CardTitle: React.FC<IProps> = ({
  bold = false,
  size,
  className = '',
  children,
}) => (
  <div
    className={cx(s.title, className, {
      [s.small]: size === 'sm',
      [s.bold]: bold,
    })}
  >
    {children}
  </div>
);

export default CardTitle;
